import { useEffect, useRef } from "react";
import * as pdfjsLib from "pdfjs-dist";

pdfjsLib.GlobalWorkerOptions.workerSrc = "https://unpkg.com/pdfjs-dist@4.0.379/build/pdf.worker.min.mjs";

export const SfPdfPages = ({ url }) => {
  const box = useRef(null);
  useEffect(() => {
    let on = true;
    (async () => {
      const buf = await (await fetch(url)).arrayBuffer();
      const pdf = await pdfjsLib.getDocument({ data: buf }).promise;
      if (!on || !box.current) return;
      box.current.innerHTML = "";
      for (let i = 1; i <= pdf.numPages && on; i++) {
        const page = await pdf.getPage(i);
        const vp = page.getViewport({ scale: 1.6 });
        const c = document.createElement("canvas");
        c.width = vp.width; c.height = vp.height;
        c.className = "mx-auto mb-3 shadow bg-white max-w-full h-auto";
        box.current?.appendChild(c);
        await page.render({ canvasContext: c.getContext("2d"), viewport: vp }).promise;
      }
    })().catch(() => {});
    return () => { on = false; };
  }, [url]);
  return <div ref={box} className="w-full h-full overflow-auto p-3" data-testid="sf-preview-pdf" />;
};
